export default "__VITE_ASSET__edb1f418__"